import { render, staticRenderFns } from "./OgmRemediationVueContainer.vue?vue&type=template&id=0941b485&scoped=true"
import script from "./OgmRemediationVueContainer.vue?vue&type=script&lang=js"
export * from "./OgmRemediationVueContainer.vue?vue&type=script&lang=js"
import style0 from "./OgmRemediationVueContainer.vue?vue&type=style&index=0&id=0941b485&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0941b485",
  null
  
)

export default component.exports